import { useQuery } from '@tanstack/react-query';
import { get } from '../api/api';
import { API_URLS } from '../constants/apiUrl';
import { IAccountProfile } from '../interface/user';

export const useFetchAccountProfile = () => {
  const query = useQuery<IAccountProfile, Error>({
    queryKey: ['account-profile'],
    queryFn: async () => {
      const response = await get(API_URLS.ACCOUNT_PROFILE);
      return response;
    },
    enabled: true,
  });

  return query;
};
